import React, { useContext } from 'react';
import { InputField } from '@trp-beacon-ui-kit/react-controls';
import { FlowContext } from '../../core/flow-engine';
import SectionHeading from '../Typography/SectionHeading/SectionHeading';
import { MFBeaconButton } from '../Beacon/BeaconComponents';
import { shouldDisableUsername } from './utils';
import styles from './FONASUCreateCredentials.css';

const FONASUCreateCredentials = ({ showSuccess, isValid }) => {
  const context = useContext(FlowContext);
  const {
    formProps,
    next,
    appState: {
      store: {
        loadedData: { tempPassword, loginID }
      }
    }
  } = context;

  const disableUsername = shouldDisableUsername(
    showSuccess,
    tempPassword,
    isValid
  );

  return (
    <>
      <div className="section-header">
        <SectionHeading text="Create Credentials" />
      </div>
      <div className="section-content">
        <div className="qv-row">
          <div className="qv-col">
            <InputField
              type="text"
              title="Choose a User Name"
              placeholder="User Name"
              {...formProps.username}
              defaultValue={loginID}
              disabled={disableUsername}
            />
          </div>
        </div>
        <div className="qv-row">
          {tempPassword && (
            <div className="qv-col">
              <InputField
                title="Temporary Password"
                placeholder="Password"
                {...formProps.password}
                defaultValue={tempPassword}
                disabled={showSuccess || tempPassword}
              />
            </div>
          )}
          {!tempPassword && (
            <div className="qv-col btn-container">
              <MFBeaconButton
                onClick={next('username')}
                disabled={!isValid}
                variant="primary"
                label="Create Password"
              />
            </div>
          )}
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default FONASUCreateCredentials;
